import { atomWithHash } from '@heidi/utils/jotai-helpers';
import { atom } from 'jotai';

import { type EditTemplateType } from '../../contracts';

export interface CreateTemplateModalState {
  open: boolean;
  isFrom?:
    | 'document_modal'
    | 'note_structure_modal'
    | 'existing_note_modal'
    | 'template_table'
    | 'create_template_modal'
    | 'ask_ai';
  /** Analytics-only: the prompt behind an `ask_ai` creation. */
  aiCommandText?: string;
}

export const createTemplateModalAtom = atom<CreateTemplateModalState>({
  open: false,
});

export const withAiTemplateContentAtom = atom({
  isStreaming: false,
});

export const editTemplateModalOpenAtom = atom<EditTemplateType>(null);

export const editExistingNoteModalOpenAtom = atomWithHash<EditTemplateType>(
  'editExistingNoteModalOpenAtom',
  null,
  {
    // to replace the current URL without adding a new entry to the history
    setHash: 'replaceState',
  }
);
